<template>
  <div class="container sv021">
    <BreadcrumbGroup :items="breadcrumbItems" />

    <HeadingOne>いくら借りられるの？チェック</HeadingOne>

    <div v-if="errors.length > 0" class="alert alert-danger" role="alert">
      <strong>下記の項目の入力に誤りがあります。</strong>
      <ul>
        <li v-for="error in errors" :key="error.id">{{ error }}</li>
      </ul>
    </div>

    <p v-if="!showResult" class="_mb-md-60 _mb-sm-40">
      いくら借りられるかを知りたい方に！2つの項目を入力するだけで、お借り入れ可能な金額がわかります。
    </p>

    <!-- ここから1つ目 -->
    <section v-if="!showResult">
      <CardGroups class="_mb-md-30 _mb-sm-20">
        <CardBox>
          <CardHeader>
            <BtnToggle collapse-target="accordion0" class="-plus">
              <h3 class="heading">お申し込み条件をご確認ください</h3>
            </BtnToggle>
          </CardHeader>
          <CollapseItem id="accordion0" accordion="accordion" :visible="true">
            <CardBody>
              <ListGroup class="-normal">
                <ListItem class="-normal">ご本人さま名義のau IDをお持ちのお客さま（法人契約でご利用のau IDではお申込みいただけません）</ListItem>
                <ListItem class="-normal">満20歳以上、70歳以下のお客さま</ListItem>
                <ListItem class="-normal">ご本人さまに定期収入のある方</ListItem>
                <ListItem class="-normal">携帯電話をお持ちのお客さま</ListItem>
                <ListItem class="-normal">現住所が国内にある方</ListItem>
              </ListGroup>
              <ListGroup class="-note">
                <ListItem class="-note">年金を受給されている場合は、年金以外に安定した収入がある方に限ります。</ListItem>
                <ListItem class="-note -red">ご利用時にSMSの追加認証がございます。</ListItem>
                <ListItem class="-note">au PAY カードをお持ちで、キャッシングサービス/キャッシング月々返済（カードローン）をお申し込み中、またはすでに設定されている方は、お申し込みいただけない場合がございます。</ListItem>
              </ListGroup>
            </CardBody>
          </CollapseItem>
        </CardBox>
      </CardGroups>

      <TableGroup>
        <TableBox class="_mb-10">
          <TableBody>
            <TableRow>
              <TableHeader
                >年収<small>（税込）</small
                ><small class="moji">【半角数字】</small>
              </TableHeader>
              <TableData :has-error="errors['income']">
                <InputGroup :errors="errors" :prop-names="['income']">
                  <InputgroupAppend>
                    <InputItem
                      id="income"
                      v-model="income"
                      type="text"
                      class="-sm"
                      empty-color="true"
                      :maxlength="11"
                    ></InputItem>
                    <InputAppend>万円</InputAppend>
                  </InputgroupAppend>
                  <InputLabel>入力例：350万円の場合「350」</InputLabel>
                </InputGroup>
              </TableData>
            </TableRow>
            <TableRow>
              <TableHeader>
                他社のお借り入れ状況<small>（金額）</small
                ><small class="moji">【半角数字】</small>
                <TooltipsItem clazz="question-box">
                  他社のお借り入れがない場合は0を入力してください。
                  <br />
                  住宅・自動車ローンは除外した金額を入力してください。
                </TooltipsItem>
              </TableHeader>
              <TableData :has-error="errors['debt']">
                <InputGroup :errors="errors" :prop-names="['debt']">
                  <InputgroupAppend>
                    <InputItem
                      id="debt"
                      v-model="debt"
                      type="text"
                      class="-sm"
                      empty-color="true"
                      :maxlength="4"
                    ></InputItem>
                    <InputAppend>万円</InputAppend>
                  </InputgroupAppend>
                  <InputLabel>入力例：20万円の場合「20」</InputLabel>
                </InputGroup>
              </TableData>
            </TableRow>
            <!--<TableRow>-->
            <!--<TableHeader>-->
            <!--借り入れご希望額-->
            <!--</TableHeader>-->
            <!--<TableData>-->
            <!--<btngroup-radio>-->
            <!--<btn-radio v-for="(serviceExpectation, index) in serviceExpectations" v-model="check.expectation"-->
            <!--:key="'serviceExpectation' + index" :id="'serviceExpectation' + index" name="serviceExpectation"-->
            <!--:value="serviceExpectation['value']" :label="serviceExpectation['name']">-->
            <!--</btn-radio>-->
            <!--</btngroup-radio>-->
            <!--</TableData>-->
            <!--</TableRow>-->
          </TableBody>
        </TableBox>
      </TableGroup>
      <ListGroup class="-note _mb-md-60 _mb-sm-40">
        <ListItem class="-note"
          >診断結果は、ご入力情報に基づいた簡易なものとなります。</ListItem
        >
        <ListItem class="-note"
          >実際のお申し込みでは、審査の状況によりご希望に添えない場合がございますので、あらかじめご了承下さい。</ListItem
        >
      </ListGroup>
      <BtngroupSingle class="-margin-lg">
        <BtnMain class="-main" @click.prevent="goCheck"> 診断する </BtnMain>
      </BtngroupSingle>
    </section>
    <!-- ここまで1つ目 -->

    <section v-if="showResult">
      <div v-if="loanableAmount > 0">
        <HeadingTwo>チェック結果</HeadingTwo>
        <div class="ribbon">
          <span>診断<br />結果</span>
        </div>
        <NoticeBox class="-success _mb-md-120 _mb-sm-60">
          <NoticeHeader>
            <p class="headingsm _mt-sm-30">ご入力いただいた情報では</p>
            <h3 class="headinglg">
              {{ loanableAmount }}万円までご融資可能と思われます
            </h3>
          </NoticeHeader>
          <NoticeBody>
            <p class="_mb-md-30">
              au PAY
              スマートローンのお申し込みはパソコン・スマートフォンでWEB完結！
            </p>
            <template v-if="isWebView()">
              <BtngroupSingle class="_mb-md-30 _mb-sm-20">
                <BtnMain class="-main" href="/entry/agreement">
                  今すぐ申し込む
                </BtnMain>
              </BtngroupSingle>
            </template>
            <template v-else>
              <BtngroupSingle class="_mb-md-30 _mb-sm-20">
                <BtnMain class="-main" router-name="en001">
                  今すぐ申し込む
                </BtnMain>
              </BtngroupSingle>
            </template>
            <BtngroupSingle class="_mb-md-60 _mb-sm-40">
              <BtnBack class="-back -md" @click.prevent="goReCheck">
                もう一度チェックする
              </BtnBack>
            </BtngroupSingle>

            <ListGroup class="-note _textleft">
              <ListItem class="-note"
                >診断結果は、ご入力いただいた情報に基づいた簡易的なものとなります。</ListItem
              >
              <ListItem class="-note"
                >実際のお申し込みでは、審査の状況によりご希望に添えない場合がございますので、あらかじめご了承ください。</ListItem
              >
            </ListGroup>

            <div class="row">
              <ListGroup class="col-12 col-md-6 -twocolumn">
                <ListItem class="-link" router-name="sv045"
                  >お申し込み条件・お手続きの流れ</ListItem
                >
                <ListItem class="-link" router-name="sv052"
                  >ご返済シミュレーション</ListItem
                >
              </ListGroup>
              <ListGroup class="col-12 col-md-6 -twocolumn">
                <ListItem class="-link" router-name="sv046"
                  >お借り入れについて</ListItem
                >
              </ListGroup>
            </div>
          </NoticeBody>
        </NoticeBox>
      </div>

      <div v-else>
        <HeadingTwo>チェック結果</HeadingTwo>
        <div class="ribbon">
          <span>診断<br />結果</span>
        </div>
        <NoticeBox class="-cancel _mb-md-30 _mb-sm-30">
          <NoticeHeader>
            <h3 class="headinglg _mt-30">
              ご入力いただいた情報では<br />お借り入れが可能か算出できませんでした
            </h3>
          </NoticeHeader>
          <NoticeBody
            >ご入力いただいた内容に誤りがある場合は「もう一度チェックする」を押して、正しい情報をご入力のうえ再度診断ください。</NoticeBody
          >
          <BtngroupSingle class="_mb-md-40 _mb-sm-20 _mt-md-30 _mt-sm-20">
            <BtnBack class="-back -md" @click.prevent="goReCheck">
              もう一度チェックする
            </BtnBack>
          </BtngroupSingle>
        </NoticeBox>
        <BtngroupSingle class="_mb-md-120 _mb-sm-60">
          <template v-if="isWebView()">
            <BtnMain class="-main" href="/entry/agreement">
              新規お申し込みはこちら
            </BtnMain>
          </template>
          <template v-else>
            <BtnMain class="-main" router-name="en001">
              新規お申し込みはこちら
            </BtnMain>
          </template>
        </BtngroupSingle>
      </div>
    </section>

    <section v-if="showResult">
      <HeadingTwo v-if="loanableAmount > 0">お申し込みに迷ったら</HeadingTwo>
      <div class="row _mb-md-120 _mb-sm-60">
        <CardLink
          class="col-md-6 _mb-sm-20"
          title="au PAY スマートローンとは？"
          src="sv/sv021/img01.jpg"
          router-name="sv002"
          badge=""
        >
          au PAY スマートローンのサービスの特徴をご紹介します。
        </CardLink>
        <CardLink
          v-if="loanableAmount > 0"
          class="col-md-6"
          title="いまさら聞けない！ローンの基礎知識"
          src="sv/sv021/img02.jpg"
          router-name="sv043"
          badge=""
        >
          ローン初心者の方に向けて、ローンに関する気になる疑問や不安にお答えします。
        </CardLink>
        <CardLink
          v-if="loanableAmount < 0"
          class="col-md-6"
          title="ローンって借りすぎないかな？"
          src="sv/sv021/img02_ng.jpg"
          router-name="sv011"
          badge=""
        >
          借り入れできる金額には制限があるんです！「いつのまにか借りすぎてしまうことってないかな...？」なんて方はこちら。
        </CardLink>
      </div>
    </section>

    <section v-if="showResult">
      <ContactBox class="_mb-md-120 _mb-sm-60" />
    </section>
  </div>
  <!-- container -->
</template>

<script>
import HeadingOne from "@/components/heading/HeadingOne";
import CardGroups from "@/components/card/CardGroups";
import CardBox from "@/components/card/CardBox";
import CardHeader from "@/components/card/CardHeader";
import BtnToggle from "@/components/button/BtnToggle";
import CollapseItem from "@/components/collapse/CollapseItem";
import CardBody from "@/components/card/CardBody";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
import TableGroup from "@/components/tables/TableGroup";
import TableBox from "@/components/tables/TableBox";
import TableBody from "@/components/tables/TableBody";
import TableRow from "@/components/tables/TableRow";
import TableHeader from "@/components/tables/TableHeader";
import TableData from "@/components/tables/TableData";
import InputGroup from "@/components/input/InputGroup";
import InputgroupAppend from "@/components/input/InputgroupAppend";
import InputItem from "@/components/input/InputItem";
import InputAppend from "@/components/input/InputAppend";
import InputLabel from "@/components/input/InputLabel";
import TooltipsItem from "@/components/tooltip/TooltipsItem";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
import HeadingTwo from "@/components/heading/HeadingTwo";
import NoticeBox from "@/components/box/NoticeBox";
import NoticeHeader from "@/components/box/NoticeHeader";
import NoticeBody from "@/components/box/NoticeBody";
import BtnBack from "@/components/button/BtnBack";
import CardLink from "@/components/card/CardLink";
import ContactBox from "@/components/box/ContactBox";
import { isWebView } from "@/utils/UserAgent";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";
import { scrollTop } from "@/utils/Other";
import { setMeta } from "@/utils/Meta";

export default {
  name: "Sv021",
  components: {
    ContactBox,
    CardLink,
    BtnBack,
    NoticeBody,
    NoticeHeader,
    NoticeBox,
    HeadingTwo,
    BtnMain,
    BtngroupSingle,
    TooltipsItem,
    InputLabel,
    InputAppend,
    InputItem,
    InputgroupAppend,
    InputGroup,
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    TableGroup,
    ListItem,
    ListGroup,
    CardBody,
    CollapseItem,
    BtnToggle,
    CardHeader,
    CardBox,
    CardGroups,
    HeadingOne,
    BreadcrumbGroup,
  },
  setup() {
    setMeta({
      title: "いくら借りられるの？チェック｜お申し込み条件・お手続きの流れ",
      description:
        "お借り入れ可能かどうかをかんたんにチェックできます。au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,シュミレーション",
    });

    return {
      scrollTop,
    };
  },
  data() {
    return {
      showResult: false,
      income: "",
      debt: "",
      loanableAmount: 0,
      employmentStatus: "",
      exectation: "",
      errors: {},
      validIncome: false,
      validDebt: false,
      // serviceExpectations: serviceExpectations,
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "root",
        },
        {
          text: "お申し込み条件・お手続きの流れ",
          routerName: "sv045",
        },
        {
          text: "いくら借りられるの？チェック",
          active: true,
        },
      ],
      check: {
        expectation: "",
      },
    };
  },
  computed: {
    isDisabled: function () {
      return !this.income || !this.debt;
    },
  },
  methods: {
    goCheck() {
      this.errors = {};
      if (!this.income) {
        this.errors["income"] = ["empty"];
      } else if (isNaN(this.income) || Number(this.income) < 0) {
        this.errors["income"] = ["regex"];
      } else if (this.income.length > 11) {
        this.errors["income"] = ["maxlength"];
      }
      if (!this.debt) {
        this.errors["debt"] = ["empty"];
      } else if (isNaN(this.debt) || Number(this.debt) < 0) {
        this.errors["debt"] = ["regex"];
      } else if (this.debt.length > 4) {
        this.errors["debt"] = ["maxlength"];
      }
      if (Object.keys(this.errors).length === 0) {
        this.loanableAmount = Math.floor(
          Number(this.income) / 3 - Number(this.debt)
        );
        if (this.loanableAmount > 100) {
          this.loanableAmount = 100;
        }
        this.showResult = true;
      }
      this.scrollTop();
    },
    goReCheck() {
      this.showResult = false;
      this.loanableAmount = "0";
      this.income = "";
      this.debt = "";
      // this.employmentStatus = ''
      // this.serviceLength = ''
      this.errors = {};
    },
    isWebView: function () {
      return isWebView();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

.ribbon {
  width: 40px;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 7px;
  margin-left: 20px;
  @include mq-up(md) {
    margin-left: 27px;
    width: 80px;
    padding-top: 15px;
  }
}

.ribbon:before {
  display: inline-block;
  position: absolute;
  top: 0;
  left: 0;
  width: 40px;
  height: 40px;
  vertical-align: middle;
  text-align: center;
  content: "";
  background: $primary;
  @include mq-up(md) {
    width: 80px;
    height: 80px;
  }
}

.ribbon:after {
  position: absolute;
  width: 40px;
  content: "";
  top: 40px;
  height: 0;
  width: 0;
  border-left: 20px solid $primary;
  border-right: 20px solid $primary;
  border-bottom: 10px solid transparent;
  left: 0;
  @include mq-up(md) {
    width: 80px;
    top: 80px;
    border-left: 40px solid $primary;
    border-right: 40px solid $primary;
    border-bottom: 20px solid transparent;
  }
}

.ribbon span {
  padding: 0;
  z-index: 3;
  font-size: 10px;
  line-height: 14px;
  color: #fff;
  @include mq-up(md) {
    font-size: 20px;
    line-height: 28px;
  }
}
.-red {
  color: $danger;
}
</style>
